import { FormControlLabel, Switch } from '@mui/material';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { ZoneRoutingInfo } from '../../../store/config/types';
interface TripWizardRoundTripSwitchProps {
  routingAttributes: any;
  currentZone: number;
}
export default function TripWizardRoundTripSwitch({ routingAttributes, currentZone }: TripWizardRoundTripSwitchProps) {
  const zonesInfo: {
    [key: number]: ZoneRoutingInfo;
  } = routingAttributes?.current?.zonesInfo ?? {};
  const [isRoundTrip, setIsRoundTrip] = useState<boolean>(Boolean(zonesInfo[currentZone]?.isRoundTrip));
  const updateZoneInfo = (zoneId: number | null, updates: any) => {
    if (!routingAttributes?.current?.zonesInfo) return;
    setIsRoundTrip(!!updates.isRoundTrip);
    const effectedZoneIds = zoneId !== null ? [zoneId] : Object.keys(zonesInfo);
    const updatedZonesInfo = { ...zonesInfo };
    for (const zId of effectedZoneIds) {
      if (updatedZonesInfo[+zId]) {
        updatedZonesInfo[+zId] = { ...zonesInfo[+zId], ...updates };
      }
    }
    routingAttributes.current.zonesInfo = updatedZonesInfo;
  };
  useEffect(() => {
    setIsRoundTrip(Boolean(zonesInfo[currentZone]?.isRoundTrip));
  }, [currentZone]);
  return (
    <FormControlLabel
      control={
        <Switch
          name="isRoundTrip"
          color="primary"
          checked={isRoundTrip}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            updateZoneInfo(currentZone, { isRoundTrip: event.target.checked }); // setIsRoundTrip(event.target.checked);
          }}
        />
      }
      label="Drivers have to return (Round Trip)."
    />
  );
}
